<template>
    <modal ref="modalEditarCuenta" titulo="Editar Cuenta" tamano="modal-lg" no-aceptar adicional="Editar" @adicional="editarCuentaBancaria">
        <ValidationObserver ref="validacion">
            <div class="row mx-0 justify-center">
                <div class="col-6">
                    <ValidationProvider v-slot="{errors}" rules="required|max:100" name="nombre">
                        <p class="f-12 text-general pl-3 f-500">Nombre de la caja</p>
                        <el-input v-model="model.nombre" placeholder="Nombre" class="w-100" />
                        <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{errors}" rules="required|max:500" name="descripción">
                        <p class="f-12 text-general pl-3 f-500 mt-4">Descripción</p>
                        <el-input v-model="model.descripcion" placeholder="Descripción de la caja" type="textarea" :rows="5" class="w-100" />
                        <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div>
                <div class="col-6 mt">
                    <ValidationProvider v-slot="{errors}" rules="required" name="moneda">
                        <p class="f-12 text-general f-500 pl-3">Seleccionar moneda</p>
                        <el-select v-model="model.idm_moneda" filterable class="w-100">
                            <el-option
                            v-for="item in monedas"
                            :key="item.id"
                            :label="item.sigla"
                            :value="item.id"
                            />
                        </el-select>
                        <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                    </ValidationProvider>
                    <p class="f-12 text-general f-500 pl-3 mt-4">Seleccionar cedis</p>
                    <el-select v-model="id_cedis" filterable class="w-100" @change="addCedis">
                        <el-option
                        v-for="item in selectCedis"
                        :key="item.id"
                        :label="item.nombre"
                        :value="item.id"
                        :disabled="item.disabled"
                        />
                    </el-select>
                    <span v-if="validarCedis" class="text-danger w-100 f-11">Selecciona al menos un cedis.</span>
                    <div v-for="(c,key) in cedisAgregados" :key="key" class="row mx-0 bg-light-f5 border align-items-center pl-2 mt-2 br-5 f-14" style="height:32px;">
                        {{ c.nombre }} <i class="icon-cancel ml-auto mr-2 text-general f-16 cr-pointer" @click="removerCedis(c.id)" />
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CuentasBancarias from "~/services/flujoDinero/cuentas_bancarias";

export default {
    data(){
        return{
            cedisAgregados: [],
            id_cedis: null,
            validarCedis: false,
            model: {
                id: null,
                nombre: '',
                descripcion: '',
                idm_moneda: null,
            }
        }
    },
    computed:{
        ...mapGetters({
            monedas:'cedis/monedas',
        }),
        selectCedis(){
            return this.cedis_calculo.filter(o=>o.id != 0)
        }
    },
    watch: {
        cedisAgregados(val){
            this.validarCedis = !val.length
        },
    },
    methods: {
        toggle(model){
            this.model = _.cloneDeep(model)
            this.selectCedis.reduce((acc, el) => {
                if(el.id != 0){
                    el.disabled = model.cedis.some(ele => ele.id_cedis == el.id)
                    acc.push(el)
                }
                return acc
            }, [])
            this.cedisAgregados = this.selectCedis.filter(el => el.disabled)
            this.$refs.modalEditarCuenta.toggle();
        },
        async editarCuentaBancaria(){
            try {
                const valid = await this.$refs.validacion.validate()
                if(!this.cedisAgregados.length) this.validarCedis = true
                if(!valid || !this.cedisAgregados.length ){
                    this.notificacion('Mensaje', 'campos obligatorios', 'warning')
                    return false
                }
                this.model.cedis = this.cedisAgregados

                const { data } = await CuentasBancarias.editarCuentaBancaria(this.model)
                this.notificacion('Mensaje', data.message, 'success')
                this.$emit('editar', data.model)
                this.limpiar()
                this.$refs.modalEditarCuenta.toggle();
            } catch (error){
                this.error_catch(error)
            }
        },
        addCedis(id){
            let c = this.selectCedis.find(o=>o.id === id)
            c.disabled = true
            this.cedisAgregados.push(c)
            this.id_cedis = null
        },
        removerCedis(id){
            this.selectCedis.find(o=>o.id === id).disabled = false
            let c = this.selectCedis.find(o=>o.id === id)
            this.cedisAgregados.splice(this.cedisAgregados.indexOf(c), 1)
        },
        limpiar(){
            this.model = {
                id: null,
                nombre: '',
                descripcion: '',
                idm_moneda: null,
            }
            this.selectCedis.reduce((acc, el) => {
                if(el.id != 0){
                    el.disabled = false
                    acc.push(el)
                }
                return acc
            }, [])
            this.cedisAgregados = []
            this.validarCedis = false

            this.$refs.validacion.reset()
        }
    }
}
</script>
